module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "recruit"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.label))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1059a945!./src/components/recruit/template.html
// module id = 3562
// module chunks = 1